import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';

import { tipPropTypes } from 'redux/tipHandlers';
import UTTouchableWithoutFeedback from 'app/components/UTTouchableWithoutFeedback';

import FieldDetailFormatter from './components/FieldDetailFormatter';
import ShareLinksDropdown from './components/ShareLinksDropdown';
import styles from './styles';

function FieldDetail({ style, rowData, onClick }) {
  const fieldsToDisplay = [{ id: 0, name: '', value: rowData.description }];

  return (
    <div style={[style, styles.activeRowContent]}>
      <div style={styles.fieldContainer}>
        {fieldsToDisplay.map((field, index) => (
          <FieldDetailFormatter
            key={field.id}
            field={field}
            isLastElement={index === fieldsToDisplay.length - 1}
          />
        ))}
      </div>
      <div style={styles.buttonContainer}>
        <ShareLinksDropdown rowData={rowData} />
        <UTTouchableWithoutFeedback
          onClick={onClick}
          style={rowData.like ? styles.socialIconHeartLiked : styles.socialIconHeart}
        />
      </div>
    </div>
  );
}

FieldDetail.propTypes = {
  rowData: PropTypes.shape(tipPropTypes).isRequired,
  onClick: PropTypes.func.isRequired
};

export default Radium(FieldDetail);
